import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
export function template() {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(ItemsMenuEl, {
    attrs: {
      sections: this.helpers.projectListSections()
    }
  }));
}
